import { __decorate } from "tslib";
import { AsnProp } from "@peculiar/asn1-schema";
import { LogotypeInfo } from "./logotype_info";
import { OtherLogotypeInfo } from "./other_logotype_info";
export class LogotypeExtn {
    constructor(params = {}) {
        Object.assign(this, params);
    }
}
__decorate([
    AsnProp({ type: LogotypeInfo, context: 0, repeated: "sequence", optional: true })
], LogotypeExtn.prototype, "communityLogos", void 0);
__decorate([
    AsnProp({ type: LogotypeInfo, context: 1, optional: true })
], LogotypeExtn.prototype, "issuerLogo", void 0);
__decorate([
    AsnProp({ type: LogotypeInfo, context: 2, optional: true })
], LogotypeExtn.prototype, "subjectLogo", void 0);
__decorate([
    AsnProp({ type: OtherLogotypeInfo, context: 3, repeated: "sequence", optional: true })
], LogotypeExtn.prototype, "otherLogos", void 0);
